import { useAddArticleToCart } from "./use-add-article-to-cart"

export type CustomCombinationComponent = {
  id: string
  quantity: number
  message: string
}

export function useAddCustomCombinationToCart() {
  const { mutateAsync, isLoading, error } = useAddArticleToCart()

  async function addCustomCombinationToCart(
    components: CustomCombinationComponent[]
  ) {
    const promises = components.map(async (component) => {
      await mutateAsync({
        articleId: component.id,
        quantity: component.quantity,
        message: component.message,
      })
    })

    await Promise.all(promises)
  }

  return {
    addCustomCombinationToCart,
    isLoading,
    error,
  }
}
